import { Button, Col, Form, Modal, Row, Typography, message, Space, Checkbox, InputNumber, Tag } from "antd";
import React, { useState } from "react";
import http from "../../../../../services/http";
import { useNavigate } from "react-router-dom";
import { parseToInt, randomInt } from "../../../../../helpers/masks";
const { Text } = Typography;

const validator = {
  operacao_matematica: [{ required: true, message: "Digite a resposta!" }],
};

const ButtonLancamento = ({ id, idCandidato, nome }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [firstNumber] = useState(randomInt(9));
  const [secondNumber] = useState(randomInt(9));
  const navigate = useNavigate();

  // ENVIAR
  const salvarLancamento = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_lancamento/votar`, formulario);
    if (api.statusCode === 200) {
      navigate("/eleicoes-cipa/sucesso");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };
  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (firstNumber + secondNumber !== parseToInt(formulario?.operacao_matematica)) {
      form.setFields([
        {
          name: "operacao_matematica",
          errors: ["Resultado incorreto!"],
        },
      ]);
      return;
    }

    salvarLancamento({
      id: id,
      id_candidatos: idCandidato,
      operacao_matematica: `${firstNumber} + ${secondNumber} = ${parseToInt(formulario?.operacao_matematica)}`,
    });
  };

  return (
    <>
      <Button loading={loading} size="large" type="dashed" onClick={() => setOpen(true)}>
        VOTAR
      </Button>
      <Modal
        title="Formulário de Confirmação de Voto"
        open={open}
        onOk={() => form.submit()}
        okText="Salvar"
        width={600}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setOpen(false);
          form.resetFields();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Text strong>
                Voto: <Tag color="#60b565">{nome}</Tag>
              </Text>
            </Col>
            <br />
            <br />

            <Col className="gutter-row" span={24}>
              <Form.Item
                name="operacao_matematica"
                label="Resolva a Operação Matemática"
                rules={validator?.operacao_matematica}>
                <Space>
                  <Text style={{ fontSize: 20 }}>
                    {firstNumber} + {secondNumber} ={" "}
                  </Text>
                  <InputNumber
                    controls={false}
                    autoComplete="off"
                    className="input-number"
                    precision={0}
                    min={0}
                    style={{ width: 100 }}
                    size="large"
                    disabled={loading}
                    placeholder="..."
                  />
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default ButtonLancamento;
